<template>
  <div>
    <slot name="controls"></slot>
    <div class="p-2">
      <div class="item-title border-bottom mb-2">
        <slot name="header"></slot>
      </div>
      <div
        class="overflow-hidden"
        :style="styles"
      >
        <div ref="body">
          <slot name="body"></slot>
        </div>
      </div>
      <div v-if="isToggleBodyButtonVisible" class="d-flex justify-content-center mt-2">
        <div
          class="btn btn-small btn-invisible line-height-10 py-0"
          @click="toggleBodyExpand"
          :title="toggleBodyButtonTitle"
        >
          <i v-if="isBodyExpanded" class="fas fa-chevron-up text-muted"></i>
          <i v-else class="fas fa-chevron-down text-muted"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    minHeight: {
      type: Number,
      default: 40,
    },
    maxHeight: {
      type: Number,
      default: 200,
    },
  },

  data() {
    return {
      isBodyExpanded: false,
      isToggleBodyButtonVisible: false,
    }
  },

  computed: {
    /**
     * @return {Object}
     */
    styles() {
      return {
        'min-height': `${this.minHeight}px`,
        'max-height': this.isBodyExpanded ? 'initial' : `${this.maxHeight}px`
      };
    },

    /**
     * @return {string}
     */
    toggleBodyButtonTitle() {
      return this.isBodyExpanded ? 'Less' : 'More';
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    toggleBodyExpand() {
      this.isBodyExpanded = !this.isBodyExpanded;
    },
  },

  mounted() {
    const bodyHeight = _.get(this.$refs, 'body.clientHeight');
    this.isToggleBodyButtonVisible = _.isNumber(bodyHeight) && bodyHeight > this.maxHeight;
  }
}
</script>
